import { render } from "./VariantsAndDetailsPage.vue?vue&type=template&id=1bdc8b26&ts=true"
import script from "./VariantsAndDetailsPage.vue?vue&type=script&lang=ts"
export * from "./VariantsAndDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__